export enum Range {
  Today = "Today",
  Yesterday = "Yesterday",
  LastWeek = "Last Week",
  LastMonth = "Last Month",
  Last7Days = "Last 7 days",
  Last30Days = "Last 30 days",
}
